module.exports = __webpack_public_path__ + "static/media/logo-login.e58d5987.png";


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/kmcAssets/img/logo-login.png
// module id = 3308
// module chunks = 1137